import { render, staticRenderFns } from "./TaskIndex.vue?vue&type=template&id=222faa99"
import script from "./TaskIndex.vue?vue&type=script&lang=ts"
export * from "./TaskIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports